<label [attr.for]="inputId" class="icc-checkbox-layout" #label>
    <span class="icc-checkbox-inner-container"
    [class.icc-checkbox-inner-container-no-side-margin]="!checkboxLabel.textContent || !checkboxLabel.textContent.trim()"
    >
        <input
            #input
            type="checkbox"
            class="icc-checkbox-input cdk-visually-hidden"
            [id]="inputId"
            [required]="required"
            [checked]="checked"
            [attr.value]="value"
            [disabled]="disabled"
            [attr.name]="name"
            [tabIndex]="tabIndex"
            [attr.aria-label]="ariaLabel || null"
            [attr.aria-labelledby]="ariaLabelledby"
            [attr.aria-checked]="_getAriaChecked()"
            [attr.aria-describedby]="ariaDescribedby"
            (change)="_onInteractionEvent($event)"
            (click)="_onInputClick($event)"
        >
        <span class="icc-ripple">
            <span class="icc-ripple-element"></span>
        </span>
        <span class="icc-checkbox-focused-frame"></span>
        <span class="icc-checkbox-frame"></span>
        <span class="icc-checkbox-background">
            <icc-icon class="icc-checkbox-checkmark" name="check_box_checked"></icc-icon>
            <icc-icon class="icc-checkbox-uncheckmark" name="check_box_unchecked"></icc-icon>
            <icc-icon class="icc-checkbox-indeterminated" name="check_box_indeterminated"></icc-icon>
        </span>
    </span>
    <span class="icc-checkbox-label" #checkboxLabel (cdkObserveContent)="_onLabelTextChange()">
        <!-- Add an invisible span so JAWS can read the label -->
        <span style="display:none">&nbsp;</span>
        <ng-content></ng-content>
    </span>
</label>